<template>
  <div>
    <b-breadcrumb :items="items"></b-breadcrumb>
    <div
      v-if="busy"
      class="text-center"
      style="
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 10000;
      "
    >
      <b-spinner label="Spinning"></b-spinner>
    </div>
    <b-row class="mx-0 mb-3">
      <b-col lg="12">
        <b-card
          title="Newsletters envoyés et en cours d'envoi"
          class="bg-light shadow"
          title-tag="h6"
        >
          
          <div class="card-body" v-if="loaded" v-html="list"></div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import DateTime from "@/services/DateTime.js";
import newsletters from "@/services/newsletters.js";
export default {
  name: "NewslettersList",
  components: {},
  data() {
    return {
      items: [
       {
          text: "Gestion",
          to: { name: "home" },
        },
        {
          text: "Module d'envoi de mails massif",
          to: { name: "newsletters" },
        },
        {
          text: "Liste des envois",
          active: true,
        },
      ],
      list: {},
    
      busy: false,
      loaded: false,
    };
  },
  created() {
    this.load();
  },
  methods: {
    load() {
      this.busy = true;
      newsletters.list().then((response) => {
        this.list = response.data;
        this.busy = false;
        this.loaded = true;
      });
    },
  
    toDate(d) {
      return DateTime.humanDate(d);
    },
  },
};
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>